import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Input } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchInput = props => {
  const { className, onChange, style, ...rest } = props;

  return (
    <Paper
      {...rest}
      className={className}
      style={style}
      sx={{
        borderRadius: '4px',
        alignItems: 'center',
        p: 1,
        display: 'flex',
        flexBasis: 420,
        ...style
      }}
    >
      <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
      <Input
        {...rest}
        sx={{
          flexGrow: 1,
          fontSize: '14px',
          lineHeight: '16px',
          letterSpacing: '-0.05px'
        }}
        disableUnderline
        onChange={onChange}
      />
    </Paper>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SearchInput;
